const state = {
    startCountdown: false,
    stopCountdown: false,
    timerCountdown: 10,
}

const getters = {
    getStartCountdown: state => state.startCountdown,
    getTimerCountdown: state => state.timerCountdown,
    getStopCountdown: state => state.stopCountdown,
}

const mutations = {
    mutationTimerCountdown: (state, time) => { state.timerCountdown = time },
    mutationStartCountdown: (state, start) => { state.startCountdown = start },
    mutationStopCountdown: (state, stop) => { state.stopCountdown = stop },
}

const actions = {
    async setStartCountdown({ commit }, data) {
        if (data != state.startCountdown) {
            commit('mutationStartCountdown', data);
        }
    },
    async setTimerCountdown({ commit }, data) {
        if (data != state.timerCountdown) {
            commit('mutationTimerCountdown', data);
        }
    },
    async setStopCountdown({ commit }, data) {
        commit('mutationStopCountdown', data);
    }
}

export default {
    getters,
    mutations,
    actions,
    state
}